module.exports = __webpack_public_path__ + "img/person.52edac7c.png";